import { Article } from "./Article";

export class HowToData {

    constructor(
        public article: Article,
        public steps: HowToStep[]) {
      }
}

export interface HowToStep {
    name: string;
    text: string;
    image: string;
}